import angular from 'angular';
import classDesignerEditorComponent from './editor/class-designer-editor.component';
import classDesignerHomeComponent from './home/class-designer-home.component';
import classDesignerCommentEditorComponent
	from './comment-editor/class-designer-comment-editor.component';
import classDesignerLinkEditorComponent from './link-editor/class-designer-link-editor.component';
import classDesignerNodeEditorComponent from './node-editor/class-designer-node-editor.component';
import classDesignerLinkCommonEditorComponent
	from './link-editor/common-editor/class-designer-link-common-editor.component';

export default angular
	.module('app.admin.adminClassDesigner', [])
	.component('classDesignerEditor', classDesignerEditorComponent)
	.component('classDesignerHome', classDesignerHomeComponent)
	.component('classDesignerCommentEditor', classDesignerCommentEditorComponent)
	.component('classDesignerLinkEditor', classDesignerLinkEditorComponent)
	.component('classDesignerNodeEditor', classDesignerNodeEditorComponent)
	.component('classDesignerLinkCommonEditor', classDesignerLinkCommonEditorComponent)
	.name;
